import React, { useState, useEffect } from 'react';
import { FECHA_NAC_MIN, FECHA_NAC_MAX } from '../../components/fechaNacimiento';
import axios from '../../axiosConfig';

import { Form, Button, Alert, Modal, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import SelectComponent from '../../components/SelectComponent';
import { useLoading } from '../../components/LoadingContext';
import { ToastContainer, toast } from 'react-toastify';
import { Card, Row, Col } from 'react-bootstrap'; 
import { FaSearch } from 'react-icons/fa';  // Importamos íconos de react-icons



const userId = parseInt(localStorage.getItem('user'));  // ID del usuario logueado


const CreatePartIniciativa = () => {
  const [cedulaError, setCedulaError] = useState(''); 
  const [isCedulaValid, setIsCedulaValid] = useState(false);
  const [cedulaLengthError, setCedulaLengthError] = useState('');
  const [showConfirmModal, setShowConfirmModal] = useState(false);  
  const [showUserRoleModal, setShowUserRoleModal] = useState(false); 
  const [showUserSearchModal, setShowUserSearchModal] = useState(false);  // Modal de búsqueda de usuarios

  const [selectedUserId, setSelectedUserId] = useState(null);
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const [selectedUserName, setSelectedUserName] = useState(''); // Nombre del usuario seleccionado
  const [showRoleSearchModal, setShowRoleSearchModal] = useState(false);  // Modal de búsqueda de roles
  const [selectedRoleId, setSelectedRoleId] = useState(null);  // ID del rol seleccionado
  const [selectedRoleName, setSelectedRoleName] = useState('');  // Nombre del rol seleccionado
  const [comentario, setComentario] = useState('');
  const [redirectToCursos, setRedirectToCursos] = useState('');
  const [municipiosDisponibles, setMunicipiosDisponibles] = useState([]);  // Municipios que se mostrarán según el estado seleccionado
  const [selectVisible, setSelectVisible] = useState(false);  // Control de la visibilidad de los selectores

  const [paginatedUsers, setPaginatedUsers] = useState([]); // Usuarios en la página actual
  const [currentPageUsers, setCurrentPageUsers] = useState(1);
  

  const [paginatedRoles, setPaginatedRoles] = useState([]); // Roles en la página actual
  const [currentPageRoles, setCurrentPageRoles] = useState(1);
  const [totalPages, setTotalPages] = useState(1); // Default to 1 page initially
  const [sinCedula, setSinCedula] = useState(false);
      const userRole = localStorage.getItem('role');


  
  

  const [formData, setFormData] = useState({
    cedula_identidad: '',
    nombres: '',
    apellidos: '',
    fecha_nacimiento: '',
    direccion: '',
    email: '',
    tlf_casa: '',
    genero_id: '',
    nivel_instruccion_id: '',
    no_cedula:false,
   
  });

  const [filterOptions, setFilterOptions] = useState({
    nivelInstruccionOptions: [],
    generoOptions: [],
});




  useEffect(() => {
    handleSeleccionar();
    if (showUserSearchModal) {
      getAllUsers();
    } else if (showRoleSearchModal) {
      getAllRoles();
    }
  }, [showUserSearchModal, showRoleSearchModal]);
  
  const [filters, setFilters] = useState({
    username:'',
    name:''
  });

    


  // Al activar "sin cédula", genera código falso
  useEffect(() => {
   
    const fetchCodigoFalso = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get('/part-iniciativas-codigo-falso',{
          headers: { Authorization: `Bearer ${token}` }}

        ); // Ajusta la URL si es diferente
        setFormData(prev => ({
          ...prev,
          cedula_identidad: res.data,
        }));
      } catch (error) {
        console.error('Error generando código falso:', error);
      } finally {
      }
    };

    if (formData.no_cedula) {
      fetchCodigoFalso();
    }
  }, [formData.no_cedula]);
  

  const getAllUsers = async (page = 1) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`/users-paginate`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { ...filters, page }, // Incluye `page` en los parámetros
        });

        const { data, last_page, current_page } = response.data.users;

        // Actualizar el estado
        setPaginatedUsers(data); // Datos de la página actual
        setCurrentPageUsers(current_page); // Página actual
        setTotalPages(last_page); // Total de páginas
    } catch (error) {
        console.error('Error fetching users:', error);
        toast.error('Error fetching data');
        setPaginatedUsers([]); // Limpia los datos en caso de error
    }
};


const getAllRoles = async (page = 1) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`/role-paginate`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { ...filters, page }, // Incluye `page` en los parámetros
        });

        const { data, last_page, current_page } = response.data.roles;

        setPaginatedRoles(data); // Datos de la página actual
        setCurrentPageRoles(current_page); // Página actual
        setTotalPages(last_page); // Total de páginas
    } catch (error) {
        console.error('Error fetching roles:', error);
        toast.error('Error fetching data');
        setPaginatedRoles([]); // Limpia los datos en caso de error
    }
};




const handleFilterChange = (e) => {
  const { name, value } = e.target;
  setFilters(prev => ({ ...prev, [name]: value }));
};


const handleUserPageChange = async (newPage) => {
  if (newPage >= 1 && newPage <= totalPages) {
      await getAllUsers(newPage);
  }
};

const handleRolePageChange = async (newPage) => {
  if (newPage >= 1 && newPage <= totalPages) {
      await getAllRoles(newPage);
  }
};



  const handleSelectUser = (user) => {
    setSelectedUserId(user.id); // Guardar ID del usuario seleccionado
    setSelectedUserName(user.username); // Guardar nombre del usuario seleccionado
    setShowUserSearchModal(false); // Cerrar modal de búsqueda
    setShowConfirmModal(true); // Mostrar el modal de confirmación después de seleccionar un usuario
  };


  const handleSelectRole = (role) => {
    setSelectedRoleId(role.id);  // Guardar ID del rol seleccionado
    setSelectedRoleName(role.name);  // Guardar nombre del rol seleccionado
    setShowRoleSearchModal(false);  // Cerrar modal de búsqueda de roles
    setShowConfirmModal(true);  // Mostrar modal de confirmación
  };
  



  
  const handleSeleccionar = async () => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`/filter-datos`, {
            headers: { Authorization: `Bearer ${token}` }
        });

        const {nivel_instruccion,genero,nacionalidad,} = response.data;

        // Guardar las opciones en el estado de filterOptions
        setFilterOptions({
            nivelInstruccionOptions: nivel_instruccion,
            generoOptions: genero,
            nacionalidadOptions:nacionalidad,

        });

        setSelectVisible(true);  // Mostrar los selectores
    } catch (error) {
        console.error('Error fetching filter options:', error);
    }
};



const handleChange = (event) => {
  const { name, value, type, checked } = event.target;

  let updatedValue = value;

  if (name === 'cedula_identidad') {
    updatedValue = value.replace(/^V-/, '');  // Elimina "V-" si ya está presente
    updatedValue = updatedValue.toUpperCase(); // Convertir todo a mayúsculas

    // Permitir solo números y UNA sola 'R'
    const rCount = (updatedValue.match(/R/g) || []).length;
    updatedValue = updatedValue.replace(/[^0-9R]/gi, ''); // Permitir solo números y "R"
    
    if (rCount > 1) {
      updatedValue = updatedValue.replace(/R/g, ''); // Si hay más de una R, eliminarlas
      updatedValue += 'R'; // Volver a añadir solo una R si era válida
    }

    if (updatedValue.length < 7) {
      setCedulaLengthError('La cédula debe tener al menos 7 caracteres.');
      setIsCedulaValid(false);
    } else {
      setCedulaLengthError('');
      setIsCedulaValid(true);
    }
  }

  setFormData(prevState => ({
    ...prevState,
    [name]: type === 'checkbox' ? checked : updatedValue,
  }));
};

// handler
const handleChangeNumber = (e) => {
  const { name, value } = e.target;

  // Permitir solo dígitos
  let newValue = value.replace(/\D/g, "");

  // Evitar que el primer dígito sea 0
  if (newValue.startsWith("0")) {
    newValue = newValue.slice(1);
  }

  // Limitar longitud a 10 caracteres
  if (newValue.length > 10) {
    newValue = newValue.slice(0, 10);
  }

  setFormData((prev) => ({
    ...prev,
    [name]: newValue,
  }));
};




  const handleKeyDown = (e) => {
    // Permitir números, borrar, tabulación, eliminar y la tecla "R" (en mayúscula)
    if (
      e.key !== 'Backspace' &&
      e.key !== 'Tab' &&
      e.key !== 'Delete' &&
      e.key !== 'r' &&
      e.key !== 'R' &&
      !/[0-9]/.test(e.key)
    ) {
      e.preventDefault();
    }
  };

const handleSubmit = async (e, redirectToCursos) => {
  e.preventDefault();
  setLoading(true);

  try {
    const token = localStorage.getItem('token');
    if (!token) {
      toast.error('Error: Token no encontrado');
      setLoading(false);
      return;
    }

    const cedula = String(formData.cedula_identidad || '').trim();
    const headers = { Authorization: `Bearer ${token}` };

    // 1) Chequear existencia por cédula
    let existsResp = null;
    try {
      existsResp = await axios.get(`/part-iniciativas/cedula/${encodeURIComponent(cedula)}`, { headers });
    } catch (checkErr) {
      if (!(checkErr?.response?.status === 404)) throw checkErr;
    }
    const exists = !!(existsResp && existsResp.status === 200);
    const persona = exists ? (existsResp.data?.data ?? existsResp.data ?? {}) : null;
    const id =
      persona?.id ??
      persona?.persona_id ??
      persona?.usuario_id ??
      persona?.participante_id ??
      null;

    const payloadCreate = { ...formData };

    
      // 4) Guardar
    if (exists) {
      if (!id) {
        toast.error('No se pudo obtener el ID del participante existente.');
        setLoading(false);
        return;
      }
      await axios.put(`/part-iniciativas/${id}`, payloadCreate, { headers });
      toast.success('Participante actualizado con Éxito');
    } else {
      await axios.post(`/part-iniciativas`, payloadCreate, { headers });
      toast.success('Nuevo Participante agregado con Éxito');
    }

    navigate('/part-iniciativas');
    
  } catch (error) {
    console.error('Error en submit:', error);
    toast.error('Error al guardar Participante');
  } finally {
    setLoading(false);
  }
};



 const handleBlur = async () => {
  const cedula = String(formData.cedula_identidad || "").trim();
  if (!cedula) return;

  try {
    const token = localStorage.getItem("token");
    const res = await axios.get(`/part-iniciativas/cedula/${encodeURIComponent(cedula)}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    // existe → marca error y rellena el formulario
    setCedulaError("La cédula ya está registrada.");
    setIsCedulaValid(false);

    const persona = res.data?.data ?? res.data; // ajusta si tu API envuelve datos

    setFormData(prev => {
      const merged = { ...prev };
      // Copia solo las claves que ya existen en tu form (evita meter campos desconocidos)
      for (const k of Object.keys(prev)) {
        if (persona && Object.prototype.hasOwnProperty.call(persona, k) && persona[k] != null) {
          merged[k] = persona[k];
        }
      }
      // asegura que la cédula quede igual a lo escrito
      merged.cedula_identidad = prev.cedula_identidad;
      return merged;
    });
  } catch (error) {
    if (error?.response?.status === 404) {
      // no existe → permitir registro nuevo
      setCedulaError("");
      setIsCedulaValid(true);
    } else {
      console.error("Error checking cedula:", error);
      setCedulaError("Error verificando la cédula.");
      setIsCedulaValid(false);
    }
  }
};

  return (
    
    <div className="row" style={{ marginTop: '50px' }}>
  <div className="col-lg-7 mx-auto"> {/* Centrado del contenido */}
    <div className="card-box" style={{ padding: '20px', width: '80%', margin: '0 auto' }}>
      <meta name="csrf-token" content="{{ csrf_token() }}" />
      <h2 className="mb-2">Agregar Nuevo Participante de Iniciativas</h2>

      <Form onSubmit={(e) => handleSubmit(e, false)}
        className="custom-gutter">


            <Row className="g-2">
      <Col md={6}>
        {/* Select: ¿Sin cédula? */}
        <Form.Group controlId="no_cedula">
          <Form.Label>¿Posee Documento?</Form.Label>
          <Form.Select
            value={formData.no_cedula ? 'true' : 'false'}
            onChange={(e) => {
              const value = e.target.value === 'true';
              setFormData(prev => ({
                ...prev,
                no_cedula: value,
                // Reiniciar campos si cambia
                cedula_identidad: value ? prev.cedula_identidad : '',
              }));
            }}
          >
            <option value="false">Si</option>
            <option value="true">No</option>
          </Form.Select>
        </Form.Group>

        {!formData.no_cedula && (
          <Row className="g-2 align-items-end mt-2">
           

            <Col md={9}>
              <Form.Group controlId="cedula_identidad">
                <Form.Label>Número de Documento</Form.Label>
                <Form.Control
                  type="text"
                  name="cedula_identidad"
                  value={formData.cedula_identidad || ''}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                  onBlur={handleBlur}
                  placeholder="123321323"
                  maxLength={10}
                  required
                  className={
                    cedulaError || cedulaLengthError
                      ? 'is-invalid'
                      : isCedulaValid ? 'is-valid' : ''
                  }
                />
              </Form.Group>
            </Col>

            {cedulaError && <Alert variant="danger">{cedulaError}</Alert>}
            {!cedulaError && isCedulaValid && (
              <Form.Control.Feedback type="valid">
                Cédula disponible.
              </Form.Control.Feedback>
            )}
          </Row>
        )}

        {formData.no_cedula && (
          <div className="mt-3">
            <Form.Group controlId="cedula_falsa">
              <Form.Label>Cédula Falsa Generada</Form.Label>
              <Form.Control
                type="text"
                value={formData.cedula_identidad || ''}
                readOnly
              />
             
            </Form.Group>

           
          </div>
        )}
      </Col>
    </Row>

            <Row className="g-2"> 
            <Col md={6}>
            <Form.Group controlId="nombres">
              <Form.Label>Nombres</Form.Label>
              <Form.Control
                type="text"
                name="nombres"
                value={formData.nombres}
                onChange={handleChange}
                maxLength={255}
                
              />
            </Form.Group>
            </Col>
            <Col md={6}>
            <Form.Group controlId="apellidos">
              <Form.Label>Apellidos</Form.Label>
              <Form.Control
                type="text"
                name="apellidos"
                value={formData.apellidos}
                onChange={handleChange}
                maxLength={255}
                
              />
            </Form.Group>
            </Col>

            </Row>
            <Form.Group controlId="fecha_nacimiento">
              <Form.Label>Fecha de Nacimiento</Form.Label>
              <Form.Control
                type="date"
                name="fecha_nacimiento"
                min={FECHA_NAC_MIN}
                max={FECHA_NAC_MAX}
                value={formData.fecha_nacimiento}
                onChange={handleChange}
                
              />
            </Form.Group>
            
            <Row className="g-2"> 
            <Col md={6}>
            <SelectComponent
              options={filterOptions.generoOptions}  // Usar el estado filterOptions
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.genero_id}
              handleChange={handleChange}
              controlId="genero_id"
              label="Género"
            />
            
            </Col>
             <Col md={6}>
               <Form.Group controlId="direccion">
              <Form.Label>Dirección</Form.Label>
              <Form.Control
                as="textarea"
                name="direccion"
                value={formData.direccion}
                onChange={handleChange}
                maxLength={255}
                
              />
            </Form.Group>

             
             </Col>
            
            </Row>
           

          
            
           
            <SelectComponent
             options={filterOptions.nivelInstruccionOptions}  // Usar el estado filterOptions
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.nivel_instruccion_id}
              handleChange={handleChange}
              controlId="nivel_instruccion_id"
              label="Nivel de Instrucción"
            />
            

            <Form.Group controlId="email">
              <Form.Label>Dirección Email (Opcional)</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                
              />
            </Form.Group>
            
            <Form.Group controlId="tlf_cassa">
              <Form.Label>Teléfono de Casa (Opcional)</Form.Label>
              <Form.Control
                type="text"
                name="tlf_cassa"
                value={formData.tlf_cassa}
                onChange={handleChangeNumber}
                maxLength={30}
              />
            </Form.Group>
          



            
      <div className="button-container mt-3">
        <Button
          variant="info"
          type="submit"
          className="ms-2"
          
          onClick={(e) => { 

            e.preventDefault();  // Prevenir comportamiento por defecto
            setRedirectToCursos(false);
            handleSubmit(e, false); // Guardar y redirigir a /datos
          }}
        >
          Guardar
        </Button>

        <Button
          variant="secondary"
          onClick={() => navigate('/part-iniciativas')}  // Volver simplemente redirige a /datos sin lógica adicional
          className="ms-2"
        >
          Volver
        </Button>
       

      </div>


      </Form>

      </div>
      </div>
      

      {/* Modal para seleccionar usuario o rol */}
      <Modal show={showConfirmModal && !selectedUserId && !selectedRoleId} onHide={() => setShowConfirmModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Enviar Petición</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Seleccione si desea enviar la petición de Confirmación a un Rol o Usuario en especifico
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowUserRoleModal(false)}>
            Cancelar
          </Button>
          <Button variant="warning" onClick={() => {
            setShowUserRoleModal(false);
            setShowUserSearchModal(true);
          }}>
            Buscar Usuario
          </Button>
          <Button variant="info" onClick={() => {
            setShowUserRoleModal(false);
            setShowRoleSearchModal(true);
          }}>
            Buscar Rol
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de búsqueda de usuarios */}
      <Modal show={showUserSearchModal} onHide={() => setShowUserSearchModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Buscar Usuario</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="d-flex align-items-center">
          <Form.Control
            name="username"
            type="text"
            placeholder="Buscar por nombre"
            value={filters.username}
            onChange={handleFilterChange}
            className="me-2"
          />
          <Button 
              variant="info me-2" 
              onClick={getAllUsers}
              style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
          >
              <FaSearch className="me-1" /> {/* Ícono de lupa */}
          </Button>
          </div>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>ID</th>
                <th>Nombre</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {paginatedUsers.length > 0 ? (
                  paginatedUsers.map(user => (
                      <tr key={user.id}>
                          <td>{user.id}</td>
                          <td>{user.username}</td>
                          <td>
                          <div className="d-flex justify-content-center align-items-center">

                                <Button variant="info" onClick={() => handleSelectUser(user)} className="me-2">
                                    <i className="bi bi-check2-square"></i>
                                </Button>
                            </div>
                          </td>
                      </tr>
                  ))
              ) : (
                  <tr>
                      <td colSpan="3">No se encontraron usuarios.</td>
                  </tr>
              )}
          </tbody>

          </Table>
          <div className="d-flex justify-content-between mt-3">
          <Button
            variant="secondary"
              onClick={() => handleUserPageChange(currentPageUsers - 1)}
              disabled={currentPageUsers === 1}
          >
              Anterior
          </Button>
          
          <Button
              variant="secondary"
              onClick={() => handleUserPageChange(currentPageUsers + 1)}
              disabled={currentPageUsers === totalPages}
          >
              Siguiente
          </Button>
          


          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowUserSearchModal(false)}>
            Cerrar
          </Button>
          <Button variant="light" onClick={() => {
            setShowUserSearchModal(false);
            setShowUserRoleModal(true);
          }}>
            Volver
          </Button>
        </Modal.Footer>
      </Modal>



    

    </div>
  );
};

export default CreatePartIniciativa;
